<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes" :showFooter="showFooter">
    <form autocomplete="off">
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <h6 class="float-left mr-3">Tipo de informe</h6>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="isReportBankReader"
                   v-model.trim.lazy="isReportBankReader" :disabled="isReportRecovery">
            <label class="custom-control-label" for="isReportBankReader">Bank reader</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="isReportPromotion"
                   v-model.trim.lazy="isReportPromotion" :disabled="isReportRecovery">
            <label class="custom-control-label" for="isReportPromotion">Promociones</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="isReportPaymentsPlans"
                   v-model.trim.lazy="isReportPaymentsPlans">
            <label class="custom-control-label" for="isReportPaymentsPlans">Planes de pago</label>
            <small class="form-text text-danger" v-if="isReportPaymentsPlans && (!filters.dateFrom || !filters.dateTo)">Si no devuelve datos, por favor ponga un rango de fechas mas corto</small>
          </div>
        </div>

        <div class="col-12 col-lg-3 mb-3" v-if="(statusSelected === 'UNPAID' || statusSelected === 'CANCELED_FOR_INSURANCE_FRAUD' || statusSelected === 'CANCELED_FOR_NON_PAYMENT' || statusSelected === 'CANCELED_FOR_FRAUD') && ($store.state.roles.Backoffice_member || $store.state.roles.Backoffice_supervisor)">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="isReportRecovery"
                   v-model.trim.lazy="isReportRecovery" :disabled="isReportBankReader || isReportPromotion">
            <label class="custom-control-label" for="isReportRecovery">Recobro</label>
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 mb-3">
          <h6 class="float-left mr-3">Campos a visualizar</h6>
        </div>
        <div class="col-12">
          <a @click="all($event)" id='true' href="#">Seleccionar todo</a>&nbsp;
          <a @click="all($event)" id='false' href="#" class="ml-2">Limpiar selección</a>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="dni"
                   v-model.trim.lazy="fieldsToExtract.customer.legalIdentifier">
            <label class="custom-control-label" for="dni">DNI</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="nombre"
                   v-model.trim.lazy="fieldsToExtract.customer.name">
            <label class="custom-control-label" for="nombre">Nombre</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="apellidos"
                   v-model.trim.lazy="fieldsToExtract.customer.lastNames">
            <label class="custom-control-label" for="apellidos">Apellidos</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="email"
                   v-model.trim.lazy="fieldsToExtract.customer.email">
            <label class="custom-control-label" for="email">Email</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="numcontrato"
                   v-model.trim.lazy="fieldsToExtract.contractId">
            <label class="custom-control-label" for="numcontrato">Número de contrato</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="phone1"
                   v-model.trim.lazy="fieldsToExtract.customer.phone1">
            <label class="custom-control-label" for="phone1">Móvil</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="createdDate"
                   v-model.trim.lazy="fieldsToExtract.transDate">
            <label class="custom-control-label" for="createdDate">Inicio contratación</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="isVisibleRealEndDate"
                   v-model.trim.lazy="isVisibleRealEndDate">
            <label class="custom-control-label" for="isVisibleRealEndDate">Fin contratación</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="realEndDate"
                   v-model.trim.lazy="fieldsToExtract.realEndDate">
            <label class="custom-control-label" for="realEndDate">Fecha de baja</label>
          </div>
        </div>

        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="isVisiblePolicyType"
                   v-model.trim.lazy="isVisiblePolicyType">
            <label class="custom-control-label" for="isVisiblePolicyType">Tipo póliza</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="isVisibleNumberFees"
                   v-model.trim.lazy="isVisibleNumberFees">
            <label class="custom-control-label" for="isVisibleNumberFees">Número de cuotas</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="isVisibleTypeProduct"
                   v-model.trim.lazy="isVisibleTypeProduct">
            <label class="custom-control-label" for="isVisibleTypeProduct">Línea de negocio</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="contractStatus"
                   v-model.trim.lazy="fieldsToExtract.status">
            <label class="custom-control-label" for="contractStatus">Estado contrato</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="storeNumber"
                   v-model.trim.lazy="fieldsToExtract.branch.storeNumber">
            <label class="custom-control-label" for="storeNumber">Tienda</label>
          </div>
        </div>
        <div class="col-12 col-lg-3 mb-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="imei"
                   v-model.trim.lazy="fieldsToExtract.customer.line.product.imei">
            <label class="custom-control-label" for="imei">IMEI</label>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="birthdate"
                   v-model.trim.lazy="fieldsToExtract.customer.birthdate">
            <label class="custom-control-label" for="birthdate">Fecha de nacimiento</label>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="probability"
                   v-model.trim.lazy="fieldsToExtract.probability">
            <label class="custom-control-label" for="probability">Score</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="row" @click="openAdditionalDataFunc()">
            <div class="col-12">
              <h6 class="float-left mr-3">Campos adicionales</h6>
              <v-icon v-if="!openAdditionalData" name="fa-chevron-down" scale="0.7" />
              <v-icon v-if="openAdditionalData" name="fa-chevron-up" scale="0.7" />
            </div>
          </div>
          <div v-if="openAdditionalData">
            <div class="row mb-3">
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="tenant"
                         v-model.trim.lazy="fieldsToExtract.tenant">
                  <label class="custom-control-label" for="tenant">Distribuidor</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="merchantOrderId"
                         v-model.trim.lazy="fieldsToExtract.merchantOrderId">
                  <label class="custom-control-label" for="merchantOrderId">Id Orden del distribuidor</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="partCode"
                         v-model.trim.lazy="fieldsToExtract.customer.line.product.partCode">
                  <label class="custom-control-label" for="partCode">Id producto</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="month"
                         v-model.trim.lazy="fieldsToExtract.customer.line.penalty.renewalFees.month">
                  <label class="custom-control-label" for="month">Mes de factura</label>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="retailPrice"
                         v-model.trim.lazy="fieldsToExtract.customer.line.product.retailPrice">
                  <label class="custom-control-label" for="retailPrice">Precio</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="productName"
                         v-model.trim.lazy="fieldsToExtract.customer.line.product.name">
                  <label class="custom-control-label" for="productName">Nombre producto</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="repairExcess"
                         v-model.trim.lazy="fieldsToExtract.customer.line.policy.repairExcess">
                  <label class="custom-control-label" for="repairExcess">Coste franquicia reparación</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="logisticOrderId"
                         v-model.trim.lazy="fieldsToExtract.logisticOrderId">
                  <label class="custom-control-label" for="logisticOrderId">Pedido Logística</label>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="policyNumber"
                         v-model.trim.lazy="fieldsToExtract.customer.line.policy.policyNumber">
                  <label class="custom-control-label" for="policyNumber">Nº póliza</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="replacementExcess"
                         v-model.trim.lazy="fieldsToExtract.customer.line.policy.replacementExcess">
                  <label class="custom-control-label" for="replacementExcess">Coste franquicia sustitución</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="rentServ"
                         v-model.trim.lazy="fieldsToExtract.customer.line.payment.rentServ">
                  <label class="custom-control-label" for="rentServ">Servicio y suplido</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="taxBase"
                         v-model.trim.lazy="fieldsToExtract.customer.line.payment.taxBase">
                  <label class="custom-control-label" for="taxBase">Base imponible</label>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="vatType"
                         v-model.trim.lazy="fieldsToExtract.customer.line.payment.vatType">
                  <label class="custom-control-label" for="vatType">Tipo de impuesto</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="vat"
                         v-model.trim.lazy="fieldsToExtract.customer.line.payment.vat">
                  <label class="custom-control-label" for="vat">Importe impuesto</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="monthlyNetFee"
                         v-model.trim.lazy="fieldsToExtract.customer.line.payment.monthlyNetFee">
                  <label class="custom-control-label" for="monthlyNetFee">Cuota neta mensual</label>
                </div>
              </div>
              <div class="col-12 col-lg-3">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" id="totalFee"
                         v-model.trim.lazy="fieldsToExtract.customer.line.payment.totalFee">
                  <label class="custom-control-label" for="totalFee">Cuota mensual</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3 pt-3 pl-0">
        <div class="col-12">
          <button class="btn generalSecondaryButton float-left" data-dismiss="modal">Cerrar</button>
          <button class="btn btn-primary generalPrimaryButton float-right" @click="submit()"
                  data-dismiss="modal">Exportar</button>
        </div>
      </div>
    </form>
  </Modal>
</template>

<script>
import Modal from '../../../Shared/Modal.vue';
import apiCSV from "../../../../../repositories/apiCSV";

export default {
  name: 'ExportData',
  props: [
    'id',
    'modalTitle',
    'class',
    'showFooter',
    'filters',
    'order',
    'statusSelected',

  ],
  data() {
    return {
      classes: this.class,
      shop: true,
      openAdditionalData: false,
      salesRep: false,
      partCode: false,
      paymentDate: false,
      urlDescarga: '#',
      anotherReportSelected: false,
      recoveryReportSelected: false,
      isReportRecovery: false,
      isReportBankReader: false,
      isReportPromotion: false,
      isReportPaymentsPlans: false,
      isVisibleTypeProduct: true,
      isVisibleRealEndDate: true,
      isVisiblePolicyType: true,
      isVisibleNumberFees: true,
      fieldsToExtract: {
        probability: true,
        contractId: true,
        status: true,
        tenant: false,
        tracking: false,
        transDate: true,
        realEndDate: false,
        receipts: false,
        nextReceiptDate: false,
        merchantOrderId: false,
        latestPayedReceipt: false,
        logisticOrderId: false,
        branch: {
          channel: false,
          salesRep: false,
          storeNumber: true
        },
        customer: {
          email: true,
          lastNames: true,
          legalIdentifier: true,
          birthdate: true,
          line: {
            deliveryAddress: {
              city: false,
              postalCode: false,
              province: false,
              street: false,
            },
            product: {
              retailPrice: false,
              partCode: false,
              name: false,
              imei: true,
            },
            policy: {
              expenses: false,
              ips: false,
              monthlyGrossPolicy: false,
              monthlyNetPolicy: false,
              policyNumber: false,
              repairExcess: false,
              replacementExcess: false,
            },
            penalty: {
              cancelPenalty: false,
              renewalFees: {
                month: false,
                value: false,
              }
            },
            payment: {
              monthlyNetFee: false,
              rentServ: false,
              taxBase: false,
              totalFee: false,
              vat: false,
              vatType: false,
            }
          },
          pickup: false,
          phone1: true,
          name: true,
          address: {
            city: false,
            postalCode: false,
            province: false,
            street: false
          }
        }
      }
    };
  },
  components: {
    Modal
  },
  methods: {
    openAdditionalDataFunc() {
      this.openAdditionalData = !this.openAdditionalData;
    },
    informTypeCheck(type) {
      if (type == "bankReader" || type == "promoptions") {
        this.isReportRecovery = false;
      }else if (type == "recovery"){
        this.isReportBankReader = false
        this.isReportPromotion = false
      }
    },
    reportSelected(){

    },
    submit() {
      console.log('[EXPORT MODAL] Filtros recibidos en exportación:', this.filters);
      localStorage.setItem('downloadCSV', true);
      let effectiveIsReportRecovery = !this.isReportRecovery;
      if (this.statusSelected !== 'UNPAID' || this.statusSelected === "" ) {
        this.isReportRecovery = false;
      }

      apiCSV.getUrl(this.filters, this.fieldsToExtract, effectiveIsReportRecovery, this.isReportBankReader, this.isReportPromotion, this.isReportPaymentsPlans, this.isVisibleTypeProduct, this.isVisibleRealEndDate, this.isVisiblePolicyType, this.isVisibleNumberFees).then((res) => {
        window.location.href = res.data.data.contractExport[0].downloadLink
        localStorage.setItem('downloadCSV', false);
      }).catch((error) => {
        if (error) {
          localStorage.setItem('downloadCSV', false);
          localStorage.setItem('errorDownloadCSV', true);
        }
      });
      this.$emit('hideModalDownload', '');
    },
    all: function (event) {
      let value
      if (event.target.id == 'true') {
        value = true
      }
      else {
        value = false
      }

      this.fieldsToExtract = {
        contractId: value,
        status: value,
        tenant: value,
        tracking: value,
        transDate: value,
        realEndDate: value,
        receipts: value,
        nextReceiptDate: value,
        merchantOrderId: value,
        latestPayedReceipt: value,
        probability: value,
        branch: {
          channel: value,
          salesRep: value,
          storeNumber: value
        },
        customer: {
          email: value,
          lastNames: value,
          legalIdentifier: value,
          birthdate: value,
          line: {
            deliveryAddress: {
              city: value,
              postalCode: value,
              province: value,
              street: value,
            },
            product: {
              retailPrice: value,
              partCode: value,
              name: value,
              imei: value,
            },
            policy: {
              expenses: value,
              ips: value,
              monthlyGrossPolicy: value,
              monthlyNetPolicy: value,
              policyNumber: value,
              repairExcess: value,
              replacementExcess: value,
            },
            penalty: {
              cancelPenalty: value,
              renewalFees: {
                month: value,
                value: value,
              }
            },
            payment: {
              monthlyNetFee: value,
              rentServ: value,
              taxBase: value,
              totalFee: value,
              vat: value,
              vatType: value,
            }
          },
          pickup: value,
          phone1: value,
          name: value,
          address: {
            city: value,
            postalCode: value,
            province: value,
            street: value
          }
        }
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
